<template>
  <q-dialog v-model="isOpenSync" :persistent="loading">
    <q-card v-if="transporter.user" class="small-dialog">
      <q-card-section>
        <h6>
          <template v-if="transporterUserIsActive"> Suspend transporter </template>
          <template v-else>Enable transporter</template>
        </h6>
      </q-card-section>

      <q-card-section>
        <p v-if="transporterUserIsActive">Suspend this transporter?</p>
        <p v-else>Enable this transporter?</p>
        <p class="text-center">
          Company name:
          <span class="text-weight-bold">${this.transporter.companyName}</span>
        </p>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn v-close-popup color="muted" label="Cancel" flat :disabled="loading" />
        <q-btn color="primary" label="Confirm" flat :loading="loading" @click="changeTransporterStatus" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { getErrorMessage } from '@/utils';
import API from '@/apis';

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    transporter: {
      type: Object,
      required: true,
    },
    onTransporterStatusUpdate: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    isOpenSync: {
      get() {
        return this.isOpen;
      },
      set(value) {
        return this.$emit('update:isOpen', value);
      },
    },
    transporterUserIsActive() {
      return this.transporter?.user.isActive;
    },
  },

  methods: {
    async changeTransporterStatus() {
      try {
        this.loading = true;

        await this.$axios.request(
          API.admin.changeTransporterStatus({
            id: this.transporter.id,
            active: !this.transporterUserIsActive,
          })
        );

        this.onTransporterStatusUpdate(this.transporter.id);

        this.$q.notify({
          message: 'Transporter status successfully updated!',
          type: 'positive',
          timeout: 1000,
        });
      } catch (error) {
        this.$q.notify({
          message: getErrorMessage(error),
          type: 'negative',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.small-dialog {
  width: 300px;
  max-width: 80vw;
}
</style>
